<template>
  <v-app-bar app v-if="!$route.meta.hideMainMenu">
    <v-toolbar-title @click="goToInventory">FrigoFix v1.0.0-rc</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn v-if="!isMobile" @click="goToInventory">Inventaire</v-btn>
    <v-btn v-if="!isMobile && authStore.user.roles.includes('Product creator')" @click="goToProducts">Produits</v-btn>
    <v-btn v-if="!isMobile" @click="goToAccount">Compte</v-btn>
    <v-btn v-if="!isMobile" @click="logout()">Logout</v-btn>
    <v-app-bar-nav-icon v-if="isMobile" @click="toggleDrawer"></v-app-bar-nav-icon>
  </v-app-bar>

  <v-navigation-drawer v-model="drawer" app v-if="isMobile && !$route.meta.hideMainMenu" location="right">
    <v-list>
      <v-list-item @click="goToInventory">
        <v-list-item-title>Inventaire</v-list-item-title>
      </v-list-item>
      <v-list-item @click="goToProducts" v-if="authStore.user.roles.includes('Product creator')">
        <v-list-item-title>Produits</v-list-item-title>
      </v-list-item>
      <v-list-item @click="goToAccount">
        <v-list-item-title>Compte</v-list-item-title>
      </v-list-item>
      <v-list-item @click="logout()">
        <v-list-item-title>Logout</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>

</template>


<script>
import { useRouter } from "vue-router";
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useAuthStore } from "../store/AuthStore";

export default {
  name: "MainMenu",
  setup() {
    const drawer = ref(false);
    const router = useRouter();
    const authStore = useAuthStore();
    const showRoadMapForm= ref(false);

    // Determine if the screen size is mobile
    const isMobile = computed(() => {
      return window.innerWidth < 600; // Adjust the breakpoint as needed
    });

    const toggleDrawer = () => {
      drawer.value = !drawer.value;
    };

    const logout = () => {
      authStore.logout();
      router.push("/login")
    };

    const goToInventory = () => {
      router.push("/inventory");
      if (isMobile.value) {
        drawer.value = false; // Close the drawer after navigation
      }
    };

    const goToProducts = () => {
      router.push("/products");
      if (isMobile.value) {
        drawer.value = false; // Close the drawer after navigation
      }
    };

    const goToAccount = () => {
      router.push("/account");
      if (isMobile.value) {
        drawer.value = false; // Close the drawer after navigation
      }
    };

    // Add an event listener to handle window resize
    const handleResize = () => {
      isMobile.value = window.innerWidth < 600;
    };

    onMounted(() => {
      window.addEventListener('resize', handleResize);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', handleResize);
    });

    return {drawer, logout, toggleDrawer, goToInventory, goToProducts,goToAccount, isMobile, authStore };
  },
};
</script>

<style scoped>
/* Add any specific styles here */
</style>